import { render, staticRenderFns } from "./CheckoutsMainPage.vue?vue&type=template&id=791567ce&scoped=true&"
import script from "./CheckoutsMainPage.vue?vue&type=script&lang=js&"
export * from "./CheckoutsMainPage.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutsMainPage.vue?vue&type=style&index=0&id=791567ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791567ce",
  null
  
)

export default component.exports